var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"poster",staticClass:"poster",class:{ hide: _vm.hide, sharePost: _vm.showType == 1, showPost: _vm.showType == 2 }},[_c('canvas',{ref:"canvas"}),(_vm.posterURL)?_c('img',{staticClass:"posterImage",attrs:{"src":_vm.posterURL}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }